export enum DoughnutChartMode {
  Vehicles,
  Chargers,
}
